import { BrowserModule, Title } from '@angular/platform-browser';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { SetPageTitle } from './shared/utils/set-page-title';
import { provideRouter, Router, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { ToastrModule } from 'ngx-toastr';
import { APP_ROUTES } from './app-routing.module';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpErrorInterceptor, LoaderInterceptor, LoaderService } from './core';
import { environment } from '../environments/environment';

Sentry.init({
  dsn: 'https://45711edfd81e30d93e45a50568c18126@o4509233238573056.ingest.us.sentry.io/4510183871479808',
  sendDefaultPii: true,
  enabled: environment.production,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: false,
      showBranding: true,
      isNameRequired: true,
      isEmailRequired: true,
      formTitle: 'Report an Issue',
      messagePlaceholder: 'Please describe the issue you are experiencing.',
      submitButtonLabel: 'Send Feedback',
    }),
  ],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      ToastrModule.forRoot({
        preventDuplicates: true,
      }),
      FormlyModule.forRoot({
        extras: { lazyRender: true },
      }),
      FormlyBootstrapModule,
    ),
    LoaderService,
    Title,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: SetPageTitle, deps: [Router, Title], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    provideAnimations(),
    provideEnvironmentNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
